
import angular from "angular";
import { CommonTool } from "@modules/common/tool/common-tool";
import { AbstractPictureState, ILoadState } from "./manager/abstract-picture-state";
import { IQPPictureLoadCtrl, IQPPictureLoadScope } from "./qp-picture-loading";
import { IImageMockupRestService } from "@modules/product/mockup/rest/image-mockup-rest";
import { ImageMockupRestService } from "@modules/product/mockup/rest/image-mockup-rest.service";

import IMG_NOT_FOUND from './images/image_not_found.svg';
import { PictureLoadingState } from "./manager/picture-loading-state";
import { PictureLoadfailState } from "./manager/picture-loadfail-state";
import { PictureLoadedState } from "./manager/picture-loaded-state";

export function QpPictureLoadDirective($timeout: angular.ITimeoutService, pictureLoadedState: PictureLoadedState, pictureLoadfailState: PictureLoadfailState, pictureLoadingState: PictureLoadingState, $injector: angular.auto.IInjectorService, $http: angular.IHttpService) {
    return {
        controller: ["$translate", function ($translate) {
            let vm = this;

            vm.defaultThumbnail = "";
            // 指令默认配置
            vm.defaultOptions = {
                // 加载失败图
                missingImg: IMG_NOT_FOUND,
                // 是否需要retry
                needRetry: true,
                // Retry最大次数
                times: 10,
                // Retry间隔
                delay: 2000,
            }
            vm.errorTitle = $translate.instant('QP_PICTURE_LOADING_ERROR_TITLE_DESC');

            /**
             * @description 切换加载状态
             */
            vm.changeState = (state: AbstractPictureState) => {
                if (!vm.loadState) {
                    vm.loadState = state;
                } else if (vm.loadState.name == state.name) {
                    return
                }

                // 取消当前状态特有功能
                vm.loadState.cleanAction(vm.currentElem, vm);
                // 清除当前状态样式
                vm.loadState.cleanStyle(vm.currentElem, vm);
                // 切换状态
                vm.loadState = state;
                // 设置新状态样式
                vm.loadState.setStyle(vm.currentElem, vm);
                // 设置当前状态特有功能
                vm.loadState.setAction(vm.currentElem, vm);
            }

        }],
        require: ["qpPictureLoading"],
        restrict: 'A',
        scope: {
            loadType: "<",
            pollingConfig: "<",
            fileid: "<",
            pollCalled: "&",
            viewmodel: "=",
            missingImg: "<",
            errorTitle: "<"
        },
        link: function (scope: IQPPictureLoadScope, element: JQLite, attributes, ctrls) {
            let selfCtrl: IQPPictureLoadCtrl = ctrls[0];
            // 由于同一个页面中会同时存在多个当前指令,每个图片容器大小都不相同,因此设定一个指令ID作为唯一标识,通过这个ID创建当前指令容器大小的loading样式
            selfCtrl.id = window.borderKeyframes ? window.borderKeyframes : 1;
            window.borderKeyframes = selfCtrl.id + 1;
            selfCtrl.loadType = scope.loadType ?? "LOADING";
            selfCtrl.missingImg = scope.missingImg ?? selfCtrl.defaultOptions.missingImg;
            // selfCtrl.errorTitle = scope.errorTitle ?? "the image is break down, click to reload it again.";
            selfCtrl.errorTitle = scope.errorTitle ?? ctrls[0].errorTitle;

            selfCtrl.options = selfCtrl.defaultOptions;
            if (attributes.retryMaxtimes || attributes.retryMaxtimes == "0") {
                selfCtrl.options.times = Number(attributes.retryMaxtimes);
            }
            if (attributes.retryDelay) {
                selfCtrl.options.delay = attributes.retryDelay;
            }
            // 将当前图片Element引用存入Controller中
            selfCtrl.currentElem = element;
            // 当前指令所在的图片元素对象
            selfCtrl.imageObj = element[0] as HTMLImageElement;
            // 图片加载完成处理
            selfCtrl.imageObj.onload = imageLoaded;
            // 图片加载失败处理
            selfCtrl.imageObj.onerror = imageLoadFail;

            // 监听dataset的src变化,当src值发生改变后,重新执行加载请求
            scope.$watch(() => {
                return element[0].dataset.src
            }, (newVal, oldVal) => {
                if (newVal) {
                    loadImage();
                }
            })

            // 图片懒加载
            let oi = new IntersectionObserver((entries, self) => {
                entries.forEach(entry => {
                    // 元素可见性发生改变时触发
                    if (entry.isIntersecting) {
                        selfCtrl.entry = entry;
                        // 加载最终效果图
                        loadImage();
                    } else {
                        rejectRetry();
                    }
                })

            }, { threshold: [0] });

            $timeout(() => {
                // 设置图片初始加载状态
                selfCtrl.changeState(pictureLoadedState);
                // 初始化创建loading加载所需样式及动画
                selfCtrl.loadState.setLoadingClass(element.parent(), selfCtrl);

                oi.observe(element[0]);
            })


            /****************************************************** */

            function loadImage() {
                // Retry剩余次数
                selfCtrl.overplusTimes = selfCtrl.options.times;
                // 切换为加载中状态
                selfCtrl.changeState(pictureLoadingState);
                // 若有传入缩略图,先加载缩略图
                if (selfCtrl.imageObj.dataset.thumbnail && selfCtrl.imageObj.dataset.thumbnail != "") {
                    selfCtrl.imageObj.src = selfCtrl.imageObj.dataset.thumbnail;
                }

                // 加载最终效果图(区分加载策略)
                loadUltimate();
            }

            /**
             * @description 加载最终效果图
             */
            function loadUltimate() {
                if (selfCtrl.loadType == "LOADING") {
                    // 通过url下载
                    loadImageByBlob(selfCtrl.imageObj.dataset.src as string);
                } else if (selfCtrl.loadType == "POLLING") {
                    // 轮询
                    loadImageByPolling();
                } else {
                    throw new Error("暂不支持的加载方式");
                }
            }

            /**
             * @description 通过图片路径,使用Blob文件流下载的方式加载图片
             */
            function loadImageByBlob(imgPath: string) {
                // const imgRequest = new Request(imgPath);
                // fetch(imgRequest)
                //     .then(resp => {
                //         if (resp.ok) {
                //             return resp.blob();
                //         } else {
                //             doRetry();
                //         }
                //     })
                //     .then(imgBlob => {
                //         if (imgBlob) {
                //             let objectURL = URL.createObjectURL(imgBlob);
                //             $timeout(() => {
                //                 selfCtrl.imageObj.src = objectURL;
                //             }, 500)
                //         }
                //     })
                //     .catch(error => {
                //         // 切换加载失败
                //         selfCtrl.changeState(pictureLoadfailState);
                //     })

                // let img = new Image();
                // img.crossOrigin = 'anonymous';
                // img.src = imgPath;
                $http
                    .get<Blob>(imgPath, {
                        responseType: "blob",
                        headers: {
                            "accept": "image/avif,image/webp,image/apng,image/svg+xml,image/*,*/*;q=0.8",
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 200) {
                            let blob = resp.data;
                            let objectURL = window.URL.createObjectURL(blob);
                            selfCtrl.imageObj.src = objectURL;

                            // selfCtrl.imageObj.onload = function() {
                            //     window.URL.revokeObjectURL(objectURL);
                            // }
                        } else {
                            doRetry();
                        }
                    })
                    .catch(error => {
                        doRetry();
                        // 切换加载失败
                        // selfCtrl.changeState(pictureLoadfailState);
                    })
            }

            /**
             * @description 通过发起轮询请求的方式,加载图片
             */
            function loadImageByPolling() {
                const imageMockupRestService: IImageMockupRestService = $injector.get<ImageMockupRestService>("imageMockupRestService");
                // TODO 暂时直接把轮询Service写在程序内,后续改为通用的轮询做法(允许调用方设置轮询的请求配置)
                if (!imageMockupRestService) {
                    alert("未注入轮询Service:imageMockupRestService");
                    return;
                }
                if (!scope.fileid) {
                    console.error("未传入需查询的文件id");
                    return;
                }
                imageMockupRestService.getOne(scope.fileid).then(resp => {
                    const mockupList = resp.data;
                    // 检查Mockup图是否生成完成
                    if (mockupList.status == "SUCCESS" && mockupList.fileName && mockupList.fileName != "") {
                        // 调用Mockup生成完成后处理
                        if (scope.pollCalled) {
                            scope.pollCalled({
                                model: mockupList,
                                item: scope.viewmodel
                            });
                        }
                        // 加载完成后,将加载的图片使用src加载
                        const filePath = mockupList.fileName;
                        // TODO 后续将图片尺寸单独抽离
                        const requestPath = `/file/file/${filePath}/${element.parent()[0].offsetWidth}/${element.parent()[0].offsetHeight}`;

                        // 生成完成后,使用Blob下载Mockup图
                        loadImageByBlob(requestPath);
                        return;
                    } else if (mockupList.status == "FAILURE") {
                        // mockup效果图生成失败，图片加载为失败状态
                        selfCtrl.changeState(pictureLoadfailState);
                        // 加载失败,显示加载失败提示,用户点击图片后可重新加载
                        // selfCtrl.loadFailTips(element.parent());
                    }
                    // 加载未完成,检查是否需要retry
                    if (mockupList.status != "FAILURE" && selfCtrl.options.needRetry) {
                        doRetry();
                    }
                })
            }

            function rejectRetry() {
                selfCtrl.overplusTimes = 0;
            }

            function doRetry() {
                if (selfCtrl.overplusTimes < 1) {
                    // 结束轮询,关闭加载样式,并给出提示
                    // TODO 切换状态
                    selfCtrl.changeState(pictureLoadfailState);
                    // 执行加载完成回调

                    if (selfCtrl.entry != undefined || selfCtrl.entry != null) {
                        // 取消元素监听
                        oi.unobserve(selfCtrl.entry.target);
                    } else {
                        console.warn("selfCtrl.entry is undefined");
                    }
                    return;
                } else {
                    // 切换为加载中状态
                    selfCtrl.changeState(pictureLoadingState);
                    // 若有传入缩略图,先加载缩略图
                    if (selfCtrl.imageObj.dataset.thumbnail && selfCtrl.imageObj.dataset.thumbnail != "") {
                        selfCtrl.imageObj.src = selfCtrl.imageObj.dataset.thumbnail;
                    }
                }
                $timeout(() => {
                    selfCtrl.overplusTimes = selfCtrl.overplusTimes - 1;
                    loadUltimate();
                    // if (selfCtrl.loadType == "LOADING") {
                    //     // 通过url下载
                    //     loadImageByBlob(selfCtrl.imageObj.dataset.src as string);
                    // } else if (selfCtrl.loadType == "POLLING") {
                    //     // 重新生成
                    //     reCreatMockup();
                    // } else {
                    //     throw new Error("暂不支持的加载方式");
                    // }
                }, selfCtrl.options.delay)
            }

            selfCtrl.doRetry = doRetry;
            selfCtrl.reCreatMockup = reCreatMockup;
            /**
             * @description 重新发起生成Mockup图请求
             */
            function reCreatMockup() {
                if (selfCtrl.loadType != "POLLING" || angular.isUndefined(scope.fileid) || !scope.fileid) {
                    return;
                }

                if (selfCtrl.overplusTimes < 1) {
                    // TODO 切换状态
                    selfCtrl.changeState(pictureLoadfailState);
                    // 取消元素监听
                    oi.unobserve(selfCtrl.entry.target);
                    return;
                } else {
                    // 切换为加载中状态
                    selfCtrl.changeState(pictureLoadingState);
                    // 若有传入缩略图,先加载缩略图
                    if (selfCtrl.imageObj.dataset.thumbnail && selfCtrl.imageObj.dataset.thumbnail != "") {
                        selfCtrl.imageObj.src = selfCtrl.imageObj.dataset.thumbnail;
                    }
                }

                $timeout(() => {
                    selfCtrl.overplusTimes = selfCtrl.overplusTimes - 1;

                    const imageMockupRestService: IImageMockupRestService = $injector.get<ImageMockupRestService>("imageMockupRestService");
                    // mockupId
                    const mockupId = scope.fileid as string;

                    // TODO 修改店铺产品记载状态，图片
                    // 调重新生成的接口
                    imageMockupRestService.retry(mockupId).then(resp => {
                        const mockupList = resp.data;
                        // 检查Mockup图是否生成完成
                        if (mockupList.status == "SUCCESS" && mockupList.fileName && mockupList.fileName != "") {
                            // 调用Mockup生成完成后处理
                            if (scope.pollCalled) {
                                scope.pollCalled({
                                    model: mockupList,
                                    item: scope.viewmodel
                                });
                            }
                            // 加载完成后,将加载的图片使用src加载
                            const filePath = CommonTool.getUrlFileName(mockupList.fileName);
                            // TODO 后续将图片尺寸单独抽离
                            const requestPath = `/file/file/${filePath}/${element.parent()[0].offsetWidth}/${element.parent()[0].offsetHeight}`;

                            // 生成完成后,使用Blob下载Mockup图
                            loadImageByBlob(requestPath);
                            return;
                        } else if (mockupList.status == "FAILURE") {
                            // 生成失败,重新发起生成请求
                            reCreatMockup();
                        }
                        // 加载未完成,检查是否需要retry
                        if (mockupList.status != "FAILURE" && selfCtrl.options.needRetry) {
                            doRetry();
                        }
                    })

                }, selfCtrl.options.delay)
            }

            /**
             * 
             */
            function isUltimate(): boolean {
                // 获取当前Img元素的src,并判断当前src地址类型(Blob|Path)
                if (selfCtrl.entry && selfCtrl.entry.target) {
                    const entry = selfCtrl.entry.target as any;
                    // TODO 暂定通过判断图片src中的路径是否包含blob:字段(最终效果图都采用Blob的形式下载,并创建url后赋值给src)
                    if (entry.src.indexOf('blob:') > -1) {
                        return true
                    }
                }

                return false
            }

            /**
             * @description 图片加载完成处理
             */
            function imageLoaded() {
                // 检查当前图片路径是否是最终预览图
                if (isUltimate()) {
                    // 切换为加载完成状态
                    selfCtrl.changeState(pictureLoadedState);
                    // 执行加载完成回调

                    // 取消元素监听
                    oi.unobserve(selfCtrl.entry.target);
                }

                // 判断是否是预览图加载完成:



                // 判断是否是加载错误图加载完成

            }


            function imageLoadFail(e: any) {
                // 检查是否是最终效果图加载失败:
                if (isUltimate()) {
                    doRetry();
                } else {
                    // 检查是否是预览图加载失败:
                    // // 若有传入缩略图,先显示缩略图
                    // if (selfCtrl.imageObj.dataset.thumbnail && selfCtrl.imageObj.dataset.thumbnail != "") {
                    //     selfCtrl.imageObj.src = selfCtrl.imageObj.dataset.thumbnail;
                    // }
                }

            }
        }
    }
}


QpPictureLoadDirective.$inject = ["$timeout", "pictureLoadedState", "pictureLoadfailState", "pictureLoadingState", "$injector", "$http"];
